import Header from "../../Header/header";
import "./introduce.css"
function Intro() {
    return ( 
        <div className="intro">
            <Header/>
            <div className="intro_container"></div>
        </div>
     );
}

export default Intro;